<div>
  <custom-label  *ngIf="placeholder" [placeholder]="placeholder"></custom-label>
  <p-editor [formControl]="value"  [style]="{ height: '220px' }"></p-editor>
  <span *ngIf="form && isValidField()" class="block mt-3 ml-5 text-red-500 font-italic display-6">{{errorField()}}</span>
</div>
